import axios from 'axios'

export default defineNuxtPlugin(() => {
  const RuntimeConfig = useRuntimeConfig()
  const MAIN_API_SERVER = RuntimeConfig.public.MAIN_API

  const mainApi = axios.create({
    baseURL: MAIN_API_SERVER,
    timeout: 30000,
  })

  const authApi = axios.create({
    baseURL: MAIN_API_SERVER,
    timeout: 30000,
  })

  mainApi.interceptors.request.use(
    function (config) {
      const authStore = useAuthStore()
      if (authStore.accessToken) {
        config.headers.Authorization = `Bearer ${authStore.accessToken}`
      }
      return config
    },
    function (error) {
      return Promise.reject(error)
    },
  )

  mainApi.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      const status = error.response ? error.response.status : null
      if (status !== 401) {
        return Promise.reject(error)
      }
      // pinia store
      const authStore = useAuthStore()
      try {
        let accessToken
        if (!authStore.refreshToken) {
          await authStore.auth(true)
          accessToken = authStore.accessToken
        } else {
          // refresh token
          const result = await authApi.post('/auth/refresh-token', {
            refreshToken: authStore.refreshToken,
          })

          accessToken = result.data.accessToken

          authStore.setAccessToken(accessToken)
        }

        error.response.config.headers.Authorization = `Bearer ${accessToken}`
        return mainApi(error.response.config)
      } catch (authError) {
        // logout
        // authStore.logout()
        return Promise.reject(authError)
      }
    },
  )

  return {
    provide: {
      mainApi,
      authApi,
    },
  }
})
